import React from 'react';
import {Button, Form, Input} from "reactstrap";
import {Glob as G} from "../libs/Glob.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import LanguageSwitcher from "../controls/LanguageSwitcher.mjs";

const LoginForm = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('LoginForm');
		this.checkLogin = this.checkLogin.bind(this);
	}

	componentDidMount() {
		const v = G.getStatus('passwordChangeForUser');
		if ( v ) {
			this.setState({username: v });
			G.setStatus('passwordChangeForUser');
		}
	}

	checkLogin() {
		if (! this.state.username || ! this.state.password) return false
		this.setState({loggingIn: true});
		G.login(
			window.btoa([this.state.username,this.state.password].join(':'))
		).then(  udata=>{
			//console.log(udata);
		}).catch( e => {
			console.error( e );
			this.setState({
				password: '',
				error: e?.message || "Autenticazione fallita"
			});
			setTimeout( () => { this.setState({error: undefined});}, 2000);
		}).finally( ()=>{
			this.setState({loggingIn: false});
		});
	}

	render() {
		return(
			<div className={"Login LoginForm"} id={this.uid}>
				<h4>
					<TextLabel value={"System login"} />
				</h4>
				<div>
					<LanguageSwitcher />
					<span>
						<TextLabel value={this.state.loggingIn ? "Authenticating…" : "Authentication is mandatory"} />
					</span>
				</div>
				<Form
					key={this.props.lang}
					onSubmit={(e) => {
						e.preventDefault();
						e.stopPropagation();
						this.checkLogin();
					}}
				>
					<div>
						<Input
							type={"text"}
							value={this.state.username || ''}
							placeholder={G.label("UsernameOrEmail")}
							autoFocus={!this.state.username}
							onChange={(e) => this.setState({username: e.target.value})}
						/>
						<Input
							type={"password"}
							value={this.state.password || ''}
							autoFocus={!! this.state.username }
							placeholder={G.label("Password")}
							onChange={(e) => this.setState({password: e.target.value})}
						/>
						<div>
							{this.state.error ? (
								<p className={"error"}>
									{this.state.error}
								</p>
							) : (
								<Button
									color={"link"}
									size={"sm"}
									onClick={()=>{
										G.setStatus('passwordChangeForUser',this.state.username );
										G.setCurrentPageParam('action','forgot');
									}}
								>
									<TextLabel value={"Forgot password"}/>
								</Button>
							)}
							<Button
								type="submit"
								color="primary"
								disabled={! this.state.username || ! this.state.password || !!this.state.loggingIn}
								onClick={this.checkLogin}
							>
								Login
							</Button>
						</div>
					</div>
				</Form>
			</div>
		);
	}
}

export default LoginForm;